<template lang="pug">
  section.options-section.container
    //.chosen-block
        option-card(v-for="{title, icon}, i in options", :key="i", :title="title", :icon="icon")
    lei-popover(
    :text="tooltips.tip2")
      .options-block
        lei-popover(:text="tooltips.actionDownload")
          font-awesome-icon.option(icon="download")
        lei-popover(:text="tooltips.actionPrint")
          font-awesome-icon.option(icon="print")
        //font-awesome-icon.option(icon="stream")
        //font-awesome-icon.option(icon="bell")
</template>
<script>
import OptionCard from './OptionCard'
import LeiPopover from '../lei-components/LeiPopover'
import record from '../../constants/tooltips/record'

export default {
  components: {
    OptionCard,
    LeiPopover,
  },
  data () {
    return {
      tooltips: record,
      options: [
        {
          title: 'in my list',
          icon: 'stream',
        },
        {
          title: 'in one more list',
          icon: 'stream',
        },
        {
          title: 'recieving alert',
          icon: 'bell',
        },
      ],
    }
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"

  .options-section
    /*justify-content space-between*/
    justify-content flex-end
    margin-bottom 30px
    .chosen-block
      display flex
      align-items center
      flex-flow row wrap
      flex 1
    .options-block
      padding 10px 0
      display flex
      flex-shrink 1
      .option
        padding 5px
        color $default-color-middle
        font-size 200%
        &:hover
          cursor pointer
          color $primary-color

  @media (max-width: $laptop)
    .options-section
      margin-bottom 0
  @media (max-width: $tablet)
    .chosen-block
      justify-content space-between
    .options-section
      flex-direction column-reverse
      .options-block
        justify-content flex-end
        padding 0 0 10px

</style>



// WEBPACK FOOTER //
// src/components/record-details/OptionsSection.vue